import { Row, Col, Space, Typography } from 'antd';
import { useState, useEffect } from 'react';
import SelectCommon from '../../Select/SelectCommon';
import { InputCommon } from '../../Input/InputCommon';
import { PencilSimple, TrashSimple } from '@phosphor-icons/react';
import { ManageAttributeProps } from 'types';
import { formatMoney } from 'utils';
import { ButtonCommon } from 'components/common/Button/ButtonCommon';
import AddIcon from '@mui/icons-material/Add';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
const { Text } = Typography;

const ManageAttribute: React.FC<ManageAttributeProps> = ({
  title,
  surcharge,
  note = '',
  order,
  isEdits = true,
  onDeleteTree,
  className = '',
  onSaveChange,
  attributes,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [titleValue, setTitleValue] = useState(title);
  const [attributeId, setAttributeId] = useState('');
  const [surchargeValue, setSurchargeValue] = useState(surcharge);
  const [noteValue, setNoteValue] = useState(note);
  const [originalTitle, setOriginalTitle] = useState(title);
  const [originalSurcharge, setOriginalSurcharge] = useState(surcharge);
  const [originalNote, setOriginalNote] = useState(note);

  useEffect(() => {
    setTitleValue(title);
    const foundAttribute = attributes?.find((attr) => attr.name === title);
    if (foundAttribute) {
      setAttributeId(foundAttribute.value as string);
    }
  }, [title, attributes]);
  useEffect(() => {
    setSurchargeValue(surcharge);
  }, [surcharge]);
  const handleEdit = () => {
    setOriginalTitle(titleValue);
    setOriginalSurcharge(surchargeValue);
    setOriginalNote(noteValue);
    setIsEdit(true);
  };

  const handleSave = () => {
    onSaveChange?.({
      title: attributeId,
      surcharge: surchargeValue || 0,
      note: noteValue,
      order: order,
    });

    setIsEdit(false);
  };

  const handleCancel = () => {
    setTitleValue(originalTitle);
    setSurchargeValue(originalSurcharge);
    setNoteValue(originalNote);
    setIsEdit(false);
  };

  const handleAttributeChange = (value: string) => {
    setAttributeId(value);
    const selectedAttribute = attributes?.find((attr) => attr.value === value);
    if (selectedAttribute) {
      setTitleValue(selectedAttribute.name);
    }
  };

  return (
    <div className={`w-full ${className}`}>
      <Row align='middle' justify='space-between' className='text-black w-full' key={order}>
        <Col flex='auto'>
          <div className='flex items-center gap-8 w-full'>
            <div className='min-w-[180px]'>
              {isEdit ? (
                <SelectCommon
                  placeholderSelect='Chọn thuộc tính'
                  options={attributes?.map((attribute) => ({
                    label: attribute?.name,
                    value: attribute?.value,
                  }))}
                  selectType='filterSelect'
                  className='bg-white'
                  value={attributeId}
                  onChange={handleAttributeChange}
                />
              ) : (
                <Text className='text-sm  font-bold' style={{ margin: 0 }}>
                  {titleValue}
                </Text>
              )}
            </div>
            <div className='flex-center gap-1  max-w-[230px] w-full'>
              <Text className='whitespace-nowrap text-sm font-medium  text-black'>Giá tính thêm:</Text>
              {isEdit ? (
                <InputCommon
                  type='text'
                  placeholder='Nhập giá bán'
                  value={surchargeValue}
                  onChange={(e) => setSurchargeValue(Number(e.target.value))}
                  className='!px-3'
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSave();
                    }
                  }}
                />
              ) : (
                <Text>+{formatMoney(String(surchargeValue))} VNĐ</Text>
              )}
            </div>

            <div className='flex-center gap-1  max-w-[726px] w-full'>
              <Text className='whitespace-nowrap text-sm font-medium  text-black'>Ghi chú:</Text>
              {isEdit ? (
                <InputCommon
                  type='text'
                  placeholder='Nhập ghi chú'
                  value={noteValue}
                  onChange={(e) => setNoteValue(e.target.value)}
                  className='!px-3'
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSave();
                    }
                  }}
                />
              ) : (
                <Text className='text-sm font-medium '>{note}</Text>
              )}
            </div>
          </div>
        </Col>
        {isEdits && (
          <Col>
            <Space size='middle'>
              <ButtonCommon
                color='basic'
                fullWidth
                radius='rounded'
                size='md'
                className='bg-[var(--bgBlackOpacity)] px-3 text-black gap-2'
              >
                <AddIcon style={{ fontSize: '20px' }} />
                <span className='whitespace-nowrap'>Tạo sản phẩm gia công</span>
              </ButtonCommon>
              {isEdit ? (
                <div className='flex-center justify-center gap-2 min-w-20'>
                  <DoneRoundedIcon
                    sx={{ fontSize: 20, color: 'var(--sematicSuccessColor500)', cursor: 'pointer' }}
                    onClick={handleSave}
                  />
                  <CloseRoundedIcon
                    sx={{ fontSize: 20, color: 'var(--sematicErrorColor500)', cursor: 'pointer' }}
                    onClick={handleCancel}
                  />
                </div>
              ) : (
                <>
                  <PencilSimple size={20} onClick={handleEdit} className='cursor-pointer' />
                  <TrashSimple size={24} onClick={() => onDeleteTree?.(order)} className='cursor-pointer' />
                </>
              )}
            </Space>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ManageAttribute;
